const KEY = 'tt_settings_v1';

const DEFAULTS = {
  sound: true,
  confetti: true,
  theme: 'dark',
  welcomeMode: true
};

const listeners = new Set();

function readAll() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
  } catch {
    return { ...DEFAULTS };
  }
}

let cache = typeof window !== 'undefined' ? readAll() : { ...DEFAULTS };

export function getSetting(key) {
  return cache[key];
}

export function getAllSettings() {
  return { ...cache };
}

export function setSetting(key, value) {
  cache = { ...cache, [key]: value };
  try {
    localStorage.setItem(KEY, JSON.stringify(cache));
  } catch {}
  listeners.forEach(fn => fn(cache));
}

export function onSettingsChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
